import React, { useContext } from 'react';
import classNames from 'classnames';
import ButtonGroup from 'choerodon-ui/lib/button/ButtonGroup';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import Dropdown from './Dropdown';
import { FuncType } from '../button/interface';
import Button from '../button';
import { Placements } from './enum';
const DropdownButton = function DropdownButton(props) {
    const { prefixCls: customizePrefixCls, type, disabled, icon, size, funcType, onClick, children, className, overlay, trigger, align, hidden, buttonProps, buttonGroupPrefixCls, placement, onHiddenChange, getPopupContainer, onOverlayClick, onHiddenBeforeChange, ...restProps } = props;
    const { getProPrefixCls } = useContext(ConfigContext);
    const prefixCls = getProPrefixCls('dropdown', customizePrefixCls);
    const dropdownProps = {
        prefixCls,
        align,
        overlay,
        hidden,
        disabled: disabled || (buttonProps && buttonProps.loading),
        trigger: disabled ? [] : trigger,
        placement,
        onHiddenChange,
        onHiddenBeforeChange,
        getPopupContainer,
        onOverlayClick,
    };
    return (React.createElement(ButtonGroup, Object.assign({}, restProps, { prefixCls: buttonGroupPrefixCls, className: classNames(`${prefixCls}-button`, className, {
            [`${prefixCls}-button-raised`]: !funcType || funcType === FuncType.raised,
            [`${prefixCls}-button-flat`]: funcType === FuncType.flat,
        }) }),
        React.createElement(Button, Object.assign({}, buttonProps, { funcType: FuncType.flat, size: size, type: type, disabled: disabled, onClick: onClick }), children),
        React.createElement(Dropdown, Object.assign({}, dropdownProps), icon ?
            React.createElement(Button, { funcType: FuncType.flat, size: size, disabled: dropdownProps.disabled }, icon) :
            React.createElement(Button, { funcType: FuncType.flat, size: size, disabled: dropdownProps.disabled, icon: "arrow_drop_down" }))));
};
DropdownButton.__PRO_DROPDOWN_BUTTON = true;
DropdownButton.displayName = 'DropdownButton';
DropdownButton.defaultProps = {
    placement: Placements.bottomRight,
};
export default DropdownButton;
